// NOTE: keep this in sync with the constant in python/partner_portal/blueprints/provider_signup.py
export const EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const MAX_NAME_SEGMENT_LENGTH = 50;

// max possible email address length is
// 64 (path) + 1 (@ symbol) + 255 (domain) = 320
export const MAX_EMAIL_LENGTH = 320;

export const MAX_PHONE_LENGTH = 30;
